import { useCallback, useEffect, useRef, useState } from "react";
import { v4 } from "uuid";

export function useFilePicker(props) {
  const inputRef = useRef(null);
  const id = useRef(v4());
  const [file, setFile] = useState(null);

  useEffect(() => {
    const visualyHiddenStyles = `
        clip: rect(0 0 0 0);
        clip-path: inset(50%);
        height: 1px;
        overflow: hidden;
        position: absolute;
        white-space: nowrap;
        width: 1px;
      `;
    const input = document.createElement("input");
    input.setAttribute("type", "file");
    input.setAttribute("accept", props.format);
    input.setAttribute("style", visualyHiddenStyles);
    input.addEventListener("change", (e) => {
      const { files } = e.currentTarget;
      if (files && files.length > 0) {
        const file = files[0];
        const fileUrl = URL.createObjectURL(file);
        const fileData = { file, url: fileUrl, filename: id.current };
        setFile(fileData);
      }
    });
    document.body.appendChild(input);
    inputRef.current = input;

    return () => document.body.removeChild(input);
  }, [props.format]);

  const click = useCallback(() => {
    inputRef.current.click();
  }, [inputRef.current]);

  const dispose = useCallback(() => {
    inputRef.current.value = null;
    URL.revokeObjectURL(file ? file.url : "");
    setFile(null);
  }, [inputRef.current]);

  return { file, click, dispose };
}
